export const LOWER = 'lower';
export const UPPER = 'upper';
export const MIDDLE = 'middle';
export const ENUM = 'enum';
